var _path, _g, _path2, _path3, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRiceCooker = function SvgRiceCooker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.5 15a3.5 3.5 0 0 1-3.5 3.5H6A3.5 3.5 0 0 1 2.5 15V6.5h15z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rice-cooker_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.5,
    y: 13.5,
    fill: "#fff",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.5,
    y: 13.5,
    stroke: "currentColor",
    rx: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 13.5a2 2 0 1 0-4 0v5h4zM17.465 6.5A3.5 3.5 0 0 0 14 3.5H6a3.5 3.5 0 0 0-3.464 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.5 3a1.5 1.5 0 0 0-3 0v.5h3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 17.5,
    y: 6,
    fill: "currentColor",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 0.5,
    y: 6,
    fill: "currentColor",
    rx: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rice-cooker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 19v-5.5a2.5 2.5 0 0 0-5 0V19z"
  })))));
};
export default SvgRiceCooker;